import {
	EMAIL_DESTINATAIRE_CLIENT_PERSONNE,
	EMAIL_DESTINATAIRE_CLIENT_SOCIETE,
	EMAIL_DESTINATAIRE_CONDUCTEUR,
} from "../../utilities/Addons"

// GE-80 (Jordan 30.10) — fenêtre d'e-mail : format des pièces et taille de
// l'envoi. Miroir de utilitaires/email_documents.py (seuils, règle par
// destinataire) ; le serveur refuse aussi au-delà du maximum (400).
export const MO = 1024 * 1024
// Pièces encodées en base64 (× 4/3) + en-têtes MIME : les seuils visent la
// taille de l'E-MAIL ≈ fichiers × 1,37 (miroir de FACTEUR_EMAIL).
export const FACTEUR_EMAIL = 1.37
export const EMAIL_TAILLE_AVERTISSEMENT = 15 * MO
export const EMAIL_TAILLE_MAX = 20 * MO

// « Dossier PDF » coché par défaut sauf pour le client et le conducteur
// (règle historique GE-58 C1 : fichiers tels quels).
export const dossierParDefaut = (type) =>
	![
		EMAIL_DESTINATAIRE_CLIENT_SOCIETE,
		EMAIL_DESTINATAIRE_CLIENT_PERSONNE,
		EMAIL_DESTINATAIRE_CONDUCTEUR,
	].includes(type)

// Taille estimée (octets) de l'e-mail : `taille` de chaque pièce cochée
// (photo comptée après réduction, calculée par le serveur) × FACTEUR_EMAIL.
export const tailleEnvoi = (documents, pieces) =>
	Math.round(
		pieces.reduce((total, p) => {
			const doc = (documents || []).find(
				(d) => d.kind === p.kind && d.id === p.id,
			)
			return total + ((doc && doc.taille) || 0)
		}, 0) * FACTEUR_EMAIL,
	)

// → "ok" | "avertissement" (> 15 Mo) | "refus" (> 20 Mo)
export const niveauTaille = (octets) =>
	octets > EMAIL_TAILLE_MAX
		? "refus"
		: octets > EMAIL_TAILLE_AVERTISSEMENT
			? "avertissement"
			: "ok"

export const formatTaille = (octets) =>
	octets >= MO
		? `${(octets / MO).toFixed(1).replace(".", ",")} Mo`
		: `${Math.max(1, Math.round(octets / 1024))} Ko`
